import App from "./App.svelte";
let target = false;
let key = false;
if (document.currentScript?.hasAttribute("data-person")) {
  key = document.currentScript?.getAttribute("data-person");
} else if (document.currentScript?.hasAttribute("src")) {
  // Obtener src de la etiqueta <script> actual
  const src = document.currentScript.src;
  // Crear objeto URL para parsear parámetros
  const url = new URL(src);
  // Obtener el valor de "key"
  key = url.searchParams.get("key");
}
if (key) {
  if (document.currentScript.hasAttribute("data-widget-type")) {
    if (document.getElementById("whatapp-people-widget-" + key)) {
      target = document.getElementById("whatapp-people-widget-" + key);
    } else {
      target = document.getElementById("whatapp-people-widget");
    }
  } else if (document.currentScript.hasAttribute("data-widget-embed")) {
    if (document.getElementById("data-widget-embed-" + key)) {
      target = document.getElementById("data-widget-embed-" + key);
    } else {
      target = document.getElementById("data-widget-embed");
    }
  } else if (document.currentScript.hasAttribute("data-widget-embed-google")) {
    if (document.getElementById("data-widget-embed-google-" + key)) {
      target = document.getElementById("data-widget-embed-google-" + key);
    } else {
      target = document.getElementById("data-widget-embed-google");
    }
  }
}


console.log(target);
if (document.currentScript.hasAttribute("data-widget-type")) {
  const app = new App({
    target: target,
    props: {
      widgetType: "bigperson",
      injectObject: eval(document.currentScript.getAttribute("data-inject-object")),
      cookieOverride: eval(document.currentScript.getAttribute("data-cookie-override")),
      dataActive: eval(document.currentScript.getAttribute("data-active")),
      dataHeader: eval(document.currentScript.getAttribute("data-header")),
      landingDefault: eval(document.currentScript.getAttribute("data-landing-default")),
      src: document.currentScript.getAttribute("src"),
      inboxToken: document.currentScript.getAttribute("data-inbox-token"),
      phone: document.currentScript.getAttribute("data-phone"),
      statId: document.currentScript.getAttribute("data-stat-id"),
      showAdminFields: document.currentScript.getAttribute("data-show-admin-fields"),
      adminCreateLead: document.currentScript.getAttribute("data-admin-create-lead"),
      bookingDate: document.currentScript.getAttribute("data-booking-date"),
      bookingTime: document.currentScript.getAttribute("data-booking-time"),
    },
  });
} else if (document.currentScript.hasAttribute("data-widget-embed")) {
  const app = new App({
    target: target,
    props: {
      widgetType: "classic",
      injectObject: eval(document.currentScript.getAttribute("data-inject-object")),
      cookieOverride: eval(document.currentScript.getAttribute("data-cookie-override")),
      alwaysActive: true,
      src: document.currentScript.getAttribute("src"),
      showAdminFields: document.currentScript.getAttribute("data-show-admin-fields"),
      bookingDate: document.currentScript.getAttribute("data-booking-date"),
      bookingTime: document.currentScript.getAttribute("data-booking-time"),
    },
  });
} else if (document.currentScript.hasAttribute("data-widget-embed-google")) {
  const app = new App({
    target: target,
    props: {
      widgetType: "classic",
      injectObject: eval(document.currentScript.getAttribute("data-inject-object")),
      cookieOverride: eval(document.currentScript.getAttribute("data-cookie-override")),
      embed: true,
      alwaysActive: true,
      src: document.currentScript.getAttribute("src"),
      showAdminFields: document.currentScript.getAttribute("data-show-admin-fields"),
      bookingDate: document.currentScript.getAttribute("data-booking-date"),
      bookingTime: document.currentScript.getAttribute("data-booking-time"),
    },
  });
} else {
  const app = new App({
    target: document.body,
    props: {
      widgetType: "classic",
      injectObject: eval(document.currentScript.getAttribute("data-inject-object")),
      cookieOverride: eval(document.currentScript.getAttribute("data-cookie-override")),
      dataActive: eval(document.currentScript.getAttribute("data-active")),
      src: document.currentScript.getAttribute("src"),
      inboxToken: document.currentScript.getAttribute("data-inbox-token"),
      phone: document.currentScript.getAttribute("data-phone"),
      statId: document.currentScript.getAttribute("data-stat-id"),
      showAdminFields: document.currentScript.getAttribute("data-show-admin-fields"),
      bookingDate: document.currentScript.getAttribute("data-booking-date"),
      bookingTime: document.currentScript.getAttribute("data-booking-time"),
    },
  });
}

export default app;
